export default __webpack_public_path__ + "static/media/Group 10691.e3d2ac02.svg";